import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import VideoIcon from '../icons/video.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class VideoSpalla extends Plugin {
  static get requires() {
    return [MediaEmbed];
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('videoSpalla', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Coloque o ID do vídeo',
        icon: VideoIcon,
        tooltip: true,
      });

      // Callback executed once the image is clicked.
      view.on('execute', async () => {
        const { value: id } = await Swal.fire({
          input: 'text',
          inputPlaceholder: 'Coloque o ID do vídeo',
        });

        if (id) {
          editor.model.change((writer) => {
            const video = writer.createElement('media', {
              url: `https://beyond.spalla.io/player/?video=${id}&autoplay=0`,
            });

            // Insert the image in the current selection location.
            editor.model.insertContent(video, editor.model.document.selection);
          });
        }
      });

      return view;
    });
  }
}
